module.exports = __webpack_public_path__ + "static/angular-4a5bdb844b408a2cc0d2bf4e67ce2582.png";